'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const waitUntil=require('../../../../dist-es6/testUtils/waitUntil');
const moment=require('pulsar-utils/dist-es6/time/moment');
const IncidentViewModel=require('../../../../dist-es6/client/viewModels/incidentViewModel');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const StatisticsPanelHelpers=require('../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const Formatters=require('../../../../dist-es6/client/formatters');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');
const ErrorMessages=require('../../../../dist-es6/client/errorMessages');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');

const MaxReportDurationInDays=28;

const NumSVGsPerRasterSchedule=8;
const NumGroupsPerRasterScheduleSVG=7;

const NumSVGsPerTimelineSchedule=1;
const NumGroupsPerTimelineScheduleSVG=10;

const NumSVGsPerDaysSinceLastIncident=1;
const NumGroupsPerDaysSinceLastIncident=4;

const NumSVGsPerTotalIncidents=1;
const NumGroupsPerTotalIncidents=4;

const NumSVGsPerThresholdStatusDonut=1;
const NumGroupsPerThresholdStatusDonut=1;

const NumSVGsPerSparkline=1;
const NumGroupsPerSparkline=5;

const{MinimumStatisticsPanelDimensions:MinimumStatisticsPanelDimensions}=StatisticsPanelHelpers;let

FatigueReportController=(_class=function(_BaseController){_inherits(FatigueReportController,_BaseController);
function FatigueReportController(
$scope,
$state,
$timeout,
personalScheduleDataService,
personalIncidentsService,
intervalService,
breadcrumbsService,
socketService,
displaySettingsService,
paramSyncService,
uncaughtErrorHandler,
notificationService){_classCallCheck(this,FatigueReportController);var _this=_possibleConstructorReturn(this,

_BaseController.call(this,uncaughtErrorHandler,$timeout));

_this._assignParamsToController($state.params);

_this._updateUrlParamsFromController=paramSyncService.start(_this,$scope,function(newParams){return _this._updateControllerParamsFromUrl(newParams)});

_this._$state=$state;

_this.weekFormatter=_this.weekFormatter.bind(_this);
_this.groupFormatter=_this.groupFormatter.bind(_this);

_this._personalScheduleDataService=personalScheduleDataService;
_this._personalIncidentsService=personalIncidentsService;
_this._intervalService=intervalService;
_this._use24HourTimeline=displaySettingsService.use24HourTimeline;

_this._fatigueThreshold=null;
_this._deviationThreshold=null;
_this.isInitiallyLoading=!0;
_this._isAwaitingReload=!0;
_this._pdfBase64Data=null;
_this._socketService=socketService;
_this._notificationService=notificationService;
_this._notificationType=NotificationType.AllThresholdsExceeded;

breadcrumbsService.dropCrumb('Fatigue Report');

_this._loadScheduleData();return _this;
}FatigueReportController.prototype.

_formatIncidentTrendsDataForGraphs=function _formatIncidentTrendsDataForGraphs(incidents,dayOfLastPurgedIncident,scheduleBoundsStart){var _this2=this;
const validIncidentInterval=this._intervalService.getMonthlyLookbackIntervalIncludingCurrentDayFor(this.homeTimezone,StatisticsPanelHelpers.TotalMonthsToDisplayInGraph);

const{
filteredIncidents:filteredIncidents,
finalIncidentBeforeInterval:finalIncidentBeforeInterval}=
StatisticsPanelHelpers.filterSortedIncidentsToIntervalPlusOneBefore(incidents,validIncidentInterval);

const daysSinceLastIncidentPathStartTime=StatisticsPanelHelpers.getPathStartTimeForDaysSinceGraph(
_.get(finalIncidentBeforeInterval,'time'),
_.exists(dayOfLastPurgedIncident)?dayOfLastPurgedIncident.startOfDayInTimezone(this.homeTimezone):null,
scheduleBoundsStart,
this.personInfo.creationTime);

const incidentViewModels=filteredIncidents.map(function(i){return IncidentViewModel.createFrom(i,{code:i.code,description:i.description},_this2.timezone,_.noop)});
for(const ivm of incidentViewModels){
ivm.currentlyScopedGroupMemberships=this.groupMemberships;
}

return{
incidents:incidentViewModels,
incidentInterval:validIncidentInterval,
daysSinceLastIncidentPathStartTime:daysSinceLastIncidentPathStartTime,
panelDimensions:MinimumStatisticsPanelDimensions};

};FatigueReportController.prototype.

_updateControllerParamsFromPersonInfo=function _updateControllerParamsFromPersonInfo(personInfo){
this._personId=personInfo.id;
this._employeeId=personInfo.employeeId;
this._updateUrlParamsFromController({
id:this._personId,
employeeId:this._employeeId});

};FatigueReportController.prototype.


_loadScheduleData=function(){var ref=_asyncToGenerator(function*(){var _this3=this;
if(!_.exists(this._queryInterval)||!(this._queryInterval instanceof TimeInterval)||!_.exists(this._timezone)){
this._$state.go("fdc.features.emiratesDashboard");
return;
}

if(Math.floor(this._queryInterval.duration.totalDays())>MaxReportDurationInDays){
this._notificationService.displayNotification(`Reports are currently limited to a maximum of ${MaxReportDurationInDays} days. If this is a problem, please contact support.`,'warning');
this._$state.go("fdc.features.emiratesDashboard");
return;
}

let response=yield this._personalScheduleDataService.tryGetPersonInfoAndWeeksInQueryInterval(
{id:this._personId,employeeId:this._employeeId},
this._queryInterval,
this._timezone);

if(!_.exists(response)){
this._$state.go("fdc.features.emiratesDashboard");
return;
}

if(!_.isEqual(response.personInfo,this._personInfo)){
this._updateControllerParamsFromPersonInfo(response.personInfo);
}

this._personInfo=response.personInfo;
const reportWeeks=response.weeksInQueryInterval;

this._isAwaitingReload=!0;
this._pdfBase64Data=null;
this._triggerDigest();

let[{
weekSectionModels:weekSectionModels,
now:now,
timeOfLastScheduleUpdate:timeOfLastScheduleUpdate,
timeOfLastHosStatus:timeOfLastHosStatus,
invalidDataWarning:invalidDataWarning,
predictedWorkday:predictedWorkday,
forecastDutyInterval:forecastDutyInterval,
estimatesAsOfTime:estimatesAsOfTime,
fatigueThreshold:fatigueThreshold,
deviationThreshold:deviationThreshold,
groupMemberships:groupMemberships,
displayTimeZone:displayTimeZone,
dailyEffectiveStatuses:dailyEffectiveStatuses},
{
incidents:incidentsForTrends,
incidentTypes:incidentTypes,
dayOfLastPurgedIncident:dayOfLastPurgedIncident}]=
yield Promise.all([
this._personalScheduleDataService.getScheduleDataFor(this._personInfo,reportWeeks,this._timezone),
this._personalIncidentsService.getAllIncidentsFor(this._personId)]);


let reportInterval=TimeInterval.from(reportWeeks[0].start).to(reportWeeks[reportWeeks.length-1].end);

this._estimatesAsOfTime=estimatesAsOfTime;
this._weekSectionModels=weekSectionModels;
this._reportIntervalLabel=this.weekFormatter(reportInterval);
this._now=now;
this._timeOfLastScheduleUpdate=timeOfLastScheduleUpdate;
this._timeOfLastHosStatus=timeOfLastHosStatus;
this._invalidDataWarning=invalidDataWarning;
this._predictedWorkday=predictedWorkday;
this._forecastDutyInterval=forecastDutyInterval;
this._fatigueThreshold=fatigueThreshold;
this._deviationThreshold=deviationThreshold;
this._groupMemberships=groupMemberships;
this._displayTimeZone=displayTimeZone;
this._incidentTrendsData=this._formatIncidentTrendsDataForGraphs(incidentsForTrends,dayOfLastPurgedIncident,_.get(weekSectionModels,'0.personalSchedule.bounds.start'));
this._incidents=this._incidentTrendsData.incidents.map(function(i){return _.clone(i)}).reverse();
this._personalScheduleDataService.attachThresholdStatusesDevationAndTimezoneToIncidents(this._incidents,fatigueThreshold,deviationThreshold,this._timezone,groupMemberships);
for(const _ref of weekSectionModels){const{personalSchedule:personalSchedule,dailySchedules:dailySchedules}=_ref;
this._personalScheduleDataService.attachEffectiveThresholdsToDailySchedules(personalSchedule,dailySchedules,fatigueThreshold,deviationThreshold,this._timezone);
}
this._incidentTypes=incidentTypes;

this._isAwaitingReload=!1;
this.isInitiallyLoading=!1;

this._triggerDigest();

yield waitUntil(function(){
const rasterWeeks=angular.element('pulsar-report-raster-schedule');
const timelineWeeks=angular.element('pulsar-report-timeline-schedule');
const daysSinceLastIncident=angular.element('pulsar-days-since-last-incident-graph-panel');
const totalIncidents=angular.element('pulsar-total-incidents-graph-panel');
const thresholdStatusDonut=angular.element('pulsar-threshold-status-donut');
const sparklines=angular.element('pulsar-sparkline');

return rasterWeeks.length===reportWeeks.length&&
timelineWeeks.length===reportWeeks.length&&
_hasRenderedSchedules(rasterWeeks,NumSVGsPerRasterSchedule,NumGroupsPerRasterScheduleSVG)&&
_hasRenderedSchedules(timelineWeeks,NumSVGsPerTimelineSchedule,NumGroupsPerTimelineScheduleSVG)&&(
!_this3.includeIncidentsPage||
daysSinceLastIncident.length===1&&
totalIncidents.length===1&&
thresholdStatusDonut.length===1&&
sparklines.length===_this3._incidents.length&&
_hasRenderedSchedules(daysSinceLastIncident,NumSVGsPerDaysSinceLastIncident,NumGroupsPerDaysSinceLastIncident)&&
_hasRenderedSchedules(totalIncidents,NumSVGsPerTotalIncidents,NumGroupsPerTotalIncidents)&&
_hasRenderedSchedules(thresholdStatusDonut,NumSVGsPerThresholdStatusDonut,NumGroupsPerThresholdStatusDonut)&&
_hasRenderedSchedules(sparklines,NumSVGsPerSparkline,NumGroupsPerSparkline));
},2000);

yield this._createFatigueReport();
});function _loadScheduleData(){return ref.apply(this,arguments)}return _loadScheduleData}();FatigueReportController.prototype.


_createFatigueReport=function(){var ref=_asyncToGenerator(function*(){var _this4=this;
const{
displayTimeZone:displayTimeZone,
fatigueThreshold:fatigueThreshold,
deviationThreshold:deviationThreshold,
reportIntervalLabel:reportIntervalLabel,
timezoneDescription:timezoneDescription,
timeOfLastHosStatus:timeOfLastHosStatus,
timezone:timezone,
personInfo:personInfo}=
this;

const{firstName:firstName,lastName:lastName,employeeId:employeeId}=personInfo;

const reportFooterTimeFormatter=this._use24HourTimeline?
Formatters.timeAndFullDateInTimeZone_24Hour:
Formatters.timeAndFullDateInTimeZone;

const statusUpdateTime=tryGet(timeOfLastHosStatus).
then(function(t){return reportFooterTimeFormatter(t,timezone)}).
otherwise(void 0);

const estimatesAsOfTime=tryGet(this,'estimatesAsOfTime').
then(function(t){return reportFooterTimeFormatter(t,timezone)}).
otherwise(void 0);

yield _forImagesToLoad();

const createPdfRequest={
personInfo:{firstName:firstName,lastName:lastName,employeeId:employeeId},
formattedGroups:this.groupMemberships.map(function(g){return _this4.groupFormatter(g)}),
reportIntervalLabel:reportIntervalLabel,
fatigueThreshold:fatigueThreshold,
deviationThreshold:deviationThreshold,
displayTimeZone:displayTimeZone,
timezoneDescription:timezoneDescription,
statusUpdateTime:statusUpdateTime,
estimatesAsOfTime:estimatesAsOfTime,
reportSection:angular.element('#report-section').html().replace(/[\r\n\t]+/g,'')};


const response=yield this._socketService.sendAndWaitForResponse('GenerateFatigueReport',createPdfRequest);
if(!SocketResponse.succeeded(response)){
this.isErrored=!0;
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
this._triggerDigest();
return;
}

this._pdfBase64Data=response.body;
this._triggerDigest();
});function _createFatigueReport(){return ref.apply(this,arguments)}return _createFatigueReport}();FatigueReportController.prototype.





_assignParamsToController=function _assignParamsToController(params){
this._personId=params.id;
this._employeeId=params.employeeId;
this._queryInterval=params.interval;
this._timezone=params.timezone;
};FatigueReportController.prototype.

_updateControllerParamsFromUrl=function _updateControllerParamsFromUrl(newStateParams){
const{id:id,interval:interval,timezone:timezone,employeeId:employeeId}=newStateParams;

if(this._personId===id&&
this._employeeId===employeeId&&
this._queryInterval.equals(interval)&&
this._timezone===timezone){
return;
}

this._assignParamsToController(newStateParams);
this._loadScheduleData();
};FatigueReportController.prototype.

_safeThresholdStatusGetter=function _safeThresholdStatusGetter(propertyName){
let fatigue=_.get(this,`personalStatistics.${propertyName}`);

return this._personalScheduleDataService.getThresholdStatus(fatigue,this.fatigueThreshold);
};FatigueReportController.prototype.

























groupFormatter=function groupFormatter(group){
return group.name;
};FatigueReportController.prototype.









































































weekFormatter=function weekFormatter(weekInterval){
let weekStartString=moment(weekInterval.start).tz(this.timezone).format('MMM DD');
let weekEndString=moment(weekInterval.end-1).tz(this.timezone).format('MMM DD, YYYY');

return`${weekStartString} – ${weekEndString}`;
};_createClass(FatigueReportController,[{key:'includeIncidentsPage',get:function(){return _.get(this._incidentTypes,'length',0)>0}},{key:'pdfAsBase64',get:function(){return this._pdfBase64Data}},{key:'reportIntervalLabel',get:function(){return this._reportIntervalLabel}},{key:'timezoneDescription',get:function(){return this.homeTimezone===this.timezone?_.get(this,'_personInfo.initialLocation.description'):this.timezone}},{key:'homeTimezone',get:function(){return _.get(this,'_personInfo.homeTimezone')}},{key:'timezone',get:function(){return this._timezone}},{key:'displayTimeZone',get:function(){return this._displayTimeZone}},{key:'personInfo',get:function(){return this._personInfo}},{key:'estimatesAsOfTime',get:function(){return this._estimatesAsOfTime}},{key:'fatigueThreshold',get:function(){return this._fatigueThreshold}},{key:'deviationThreshold',get:function(){return this._deviationThreshold}},{key:'incidents',get:function(){return this._incidents}},{key:'incidentTrendsData',get:function(){return this._incidentTrendsData}},{key:'notificationType',get:function(){return this._notificationType}},{key:'groupMemberships',get:function(){return this._groupMemberships}},{key:'now',get:function(){return this._now}},{key:'timeOfLastScheduleUpdate',get:function(){return this._timeOfLastScheduleUpdate}},{key:'timeOfLastHosStatus',get:function(){return this._timeOfLastHosStatus}},{key:'invalidDataWarning',get:function(){return this._invalidDataWarning}},{key:'predictedWorkday',get:function(){return this._predictedWorkday}},{key:'forecastDutyInterval',get:function(){return this._forecastDutyInterval}},{key:'peakThresholdStatus',get:function(){return this._safeThresholdStatusGetter('maxFatigueOnDuty')}},{key:'averageThresholdStatus',get:function(){return this._safeThresholdStatusGetter('averageFatigueOnDuty')}},{key:'weekSectionModels',get:function(){return this._weekSectionModels}},{key:'showLoadingSpinner',get:function(){return!this.isErrored&&(this.isInitiallyLoading||this._isAwaitingReload||!_.exists(this._pdfBase64Data))}},{key:'sleepFormatter',get:function()

{
if(!_.exists(this._sleepFormatter)){
this._sleepFormatter=function(interval){return Formatters.timeSpanAsHoursAndMinutes(interval.duration,{colonless:!0})};
}
return this._sleepFormatter;
}}]);return FatigueReportController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_loadScheduleData',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_loadScheduleData'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'_createFatigueReport',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_createFatigueReport'),_class.prototype)),_class);


function _forImagesToLoad(){
return new Promise(function(resolve,reject){return $('body').imagesLoaded(function(){return resolve()})});
}

function _hasRenderedSchedules(parentDirectiveElements,numExpectedSvgsPerDirective,numExpectedGroupsPerSvg){
for(let i=0;i<parentDirectiveElements.length;i++){
let svgs=angular.element(parentDirectiveElements[i]).find('svg');
if(!_.exists(svgs)||svgs.length<numExpectedSvgsPerDirective){
return!1;
}

for(let j=0;j<svgs.length;j++){
const svg=angular.element(svgs[j]);
const groups=svg.find('> g');
if(!_.exists(groups)){
return!1;
}

if(svg.parent().parent().parent().prop('tagName')==='PULSAR-TIMELINE-GRAPH'){
let clipPathRects=svg.find('clipPath > rect');
if(clipPathRects.length>0){
if(!Array.from(clipPathRects).map(function(rect){return angular.element(rect).attr('height')}).
every(function(h){return h>0})){
return!1;
}
}
}

if(svg.parent().prop('tagName')==='PULSAR-TWENTY-FOUR-HOUR-AXIS-LABEL'&&groups.length===1){
continue;
}

if(groups.length<numExpectedGroupsPerSvg){
return!1;
}
}
}

return!0;
}

module.exports=FatigueReportController;
//# sourceMappingURL=fatigueReportController.js.map
